import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import FileViewer from "./FileViewer";

import "./index.css";
import * as actions from "../../../../../store/actions";
import { isValidURL } from "../../../../../utils/validation/rules";
import { convertTimeTo12HourFormatChat } from "../../../../../utils/parseDateTime";
import TextInput from "../../../../../components/formElements/input/TextInput";
import AppointmentIcon from "../../../../../components/uiElements/icons/profileIcons/AppointmentIcons";
import Modals from "../../../../../components/uiElements/popupModal/modal";

const Chat = ({
  ongoingAppointment,
  setOngoingAppointmentData,
  sendSignal,
  removeSharedDocuments,
}) => {
  const [chats, setChats] = useState([]);
  const [currentChat, setCurrentChat] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setChats(ongoingAppointment?.chats);

    scrollToBottom();
    //eslint-disable-next-line
  }, [ongoingAppointment?.chats]);
 
  let myScroll;

  const scrollToBottom = () => {
    window.scrollTo({
      top: myScroll.scrollHeight,
      behavior: "smooth",
    });
  };
  
  return (
    <>
      <Modals
        isOpen={isOpen}
        closeModal={() => setIsOpen(false)}
        onBackdropClick={true}
        onRequestClose={() => setIsOpen(false)}
        styles={{
          content: {
            minWidth: "70%",
            maxWidth: "70%",
            minHeight: "90%",
            maxHeight: "90%",
            overflowY: "scroll",
          },
        }}
        title={currentChat?.split("/")?.pop()?.split("_").slice(1).join("_")}
      >
        <React.Fragment>
          <button
            onClick={() => setIsOpen(false)}
            className="close fileClose"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <FileViewer
            fileType={currentChat?.split(".")?.pop()?.toLowerCase()}
            url={currentChat}
          />
        </React.Fragment>
      </Modals>

      <div
        style={{
          whiteSpace: "pre-wrap",
          marginTop: "5rem",
        }}
        className="mb-5 pb-5 mychats"
        ref={input => (myScroll = input)}
      >
        {chats?.map(chats.pop, [...chats])?.map(chat => (
          <>
            {/* {isValidURL(chat?.data) && chat?.participantType === "mine" && (
              <p className="pb-1">
                <button
                  onClick={() => removeSharedDocuments(chat?.data)}
                  className="closeBtn"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </p>
            )} */}
            <p
              className={"mr-auto text-left pl-3 pb-0 mb-0"}
              style={{
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              {chat?.name}
            </p>
            <p className={chat?.participantType === "mine" ? "mine" : "theirs"}>
              {chat?.type === "document" && isValidURL(chat?.data) && (
                <>
                  <span
                    onClick={() => {
                      setIsOpen(true);
                      setCurrentChat(chat?.data);
                    }}
                    style={{
                      cursor: "pointer",
                      width: "100%",
                    }}
                  >
                    <AppointmentIcon
                      type="documentIcon"
                      color={
                        chat?.participantType === "mine" ? "white" : "#333333"
                      }
                    />
                    <span className="d-inline">
                      {chat?.data
                        ?.split("/")
                        ?.pop()
                        ?.split("_")
                        .slice(1)
                        .join("_")}
                    </span>
                  </span>
                </>
              )}

              {isValidURL(chat?.data) && chat?.type !== "document" && (
                <a
                  href={chat?.data}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    color:
                      chat?.participantType === "mine" ? "white" : "#333333",
                    textDecoration: "underline",
                  }}
                >
                  {chat?.data}
                </a>
              )}

              {!isValidURL(chat?.data) &&
                chat?.type !== "document" &&
                chat?.data}
            </p>
            <p
              className={
                chat?.participantType === "mine"
                  ? "ml-auto text-right pr-3 mt-1"
                  : "mr-auto text-left pl-3 mt-1"
              }
              style={{
                fontSize: 14,
              }}
            >
              {chat?.date.substring(0,7)} {" "}{convertTimeTo12HourFormatChat(chat?.date)}
            </p>
          </>
        ))}
      </div>

      <div className="containers w-25 p-0 m-0 d-flex justify-content-center">
        <TextInput
          autoFocus
          placeholder="Message..."
          className="chat-box mx-auto d-flex justify-content-center"
          value={ongoingAppointment?.chat}
          onChange={val => setOngoingAppointmentData({ chat: val })}
          onKey={ev => {
            if (ev.key === "Enter" && ev.target?.value.length > 0) {
              sendSignal(ongoingAppointment?.chat);
              setOngoingAppointmentData({ chat: undefined });
              scrollToBottom();
              ev.preventDefault();
            }
          }}
        />
      </div>
    </>
  );
};

const mapStoreToProps = ({ dashboard, api }) => ({
  ongoingAppointment: dashboard.ongoingAppointment,
  apiUtil: api,
});

const mapDispatchToProps = dispatch => ({
  setOngoingAppointmentData: updatedData =>
    dispatch(actions.setOngoingAppointmentData(updatedData)),
  removeSharedDocuments: doc => dispatch(actions.removeSharedDocuments(doc)),
});

export default connect(mapStoreToProps, mapDispatchToProps)(Chat);
